module.exports = __webpack_public_path__ + "static/img/down_img08.png.7244933.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sptj/down_img08.png.png
// module id = zLut
// module chunks = 1